import { render, staticRenderFns } from "./ServiceCenterForm.vue?vue&type=template&id=68d8e89a"
import script from "./ServiceCenterForm.vue?vue&type=script&lang=js"
export * from "./ServiceCenterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports